import { gql } from "graphql-tag";

import { getText } from "~/slices/Text/fragment";
import { getTextBlock } from "~/slices/TextBlock/fragment";
import { getHtmlSection } from "~/slices/HtmlSection/fragment";
import { getImageSection } from "~/slices/ImageSection/fragment";
import { getSeoFields, getMetaFields } from "~/mixins/seoMixin";
import { documentLink } from "~/app/prismic/prismic-fragments";

const PAGE_TYPE = "Page";

const QUERY_PAGES = gql`
  query page($uid: String!, $lang: String!) {
    ${PAGE_TYPE}: page(uid: $uid, lang: $lang) {
      title
      navigation_links {
        ... on Navigation {
          navigation {
            navigation_label
            navigation_link {
              ...documentLink
            }
          }
        }
      }
      navigation_title
      slices: body {
        ...${PAGE_TYPE}_text
        ...${PAGE_TYPE}_image_section
        ...${PAGE_TYPE}_html_section
        ...${PAGE_TYPE}_text_block
      }
      ...${PAGE_TYPE}SEOFields
      ...${PAGE_TYPE}MetaFields
    }
  }
  ${getText(PAGE_TYPE)}
  ${getTextBlock(PAGE_TYPE)}
  ${getSeoFields(PAGE_TYPE)}
  ${getMetaFields(PAGE_TYPE)}
  ${getHtmlSection(PAGE_TYPE)}
  ${getImageSection(PAGE_TYPE)}
  ${documentLink}
`;

export { PAGE_TYPE, QUERY_PAGES };
